import { render, staticRenderFns } from "./type-article.html?vue&type=template&id=0d89582c&scoped=true&external"
import script from "./type-article.js?vue&type=script&lang=js&external"
export * from "./type-article.js?vue&type=script&lang=js&external"
import style0 from "./type-article.scss?vue&type=style&index=0&id=0d89582c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89582c",
  null
  
)

export default component.exports